import { ArrowLeftCircleIcon } from '@heroicons/react/24/outline'
import props from '../../../redux/props'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

const BackToCube = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [url, setUrl] = useState('/?popup=false')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const kandidatId = urlParams.get('kandidat')

    if (kandidatId) {
      setUrl(`/wk/${kandidatId}/?popup=false`)
    }
  }, [])

  return (
    <a href={url} className="hover:underline text-white my-3 flex gap-2 items-center">
      <ArrowLeftCircleIcon className="w-6 stroke-white" />
      {t.backToCube.cta}
    </a>
  )
}

export default BackToCube
